import { SaveOutlined } from '@ant-design/icons';
import { Button, Form, Input, message, Modal, Select } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { updateWorkspace } from 'services/api/workspace';
import ProfileContext from 'services/profileContext';

const EditWorkspaceInfoModal = ({ isOpen, onClose }) => {
  const { profile, updateProfile } = useContext(ProfileContext);
  const [loading, setLoading] = useState(false);
  const [timezones, setTimezones] = useState([]);

  useEffect(() => {
    setTimezones(Intl.supportedValuesOf('timeZone'));
  }, []);

  const onFinish = (values) => {
    setLoading(true);
    updateWorkspace(values)
      .then(() => {
        message.success('Workspace information updated');
        updateProfile();
        onClose();
      })
      .catch((error) => {
        message.error(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal open={isOpen} onCancel={onClose} footer={null}>
      <Form
        onFinish={onFinish}
        layout="vertical"
        initialValues={profile.workspace}
      >
        <Form.Item label="Name" name="name">
          <Input />
        </Form.Item>
        <Form.Item label="Timezone" name="tz">
          <Select
            showSearch={true}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {timezones.map((t) => (
              <Select.Option key={t} value={t}>
                {t}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button
            loading={loading}
            block
            type="primary"
            htmlType="submit"
            icon={<SaveOutlined />}
          >
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditWorkspaceInfoModal;
